import {
  Container, Grid, Table, TableBody, TableCell, TableHead, TableRow
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import animalApi from 'api/query/animal/animal-api';
import Axios from 'axios';
import Accordion from 'components/accordion';
import LoadContainer from 'components/load-container';
import React, { useEffect, useState } from 'react';
import { TraitObserved } from '../../../api/query/animal/trait-observed';
import { getTraitListByAnalysis } from '../../report/report-constants';
import { TraitObservedProps } from './traits-observed-props';
import './traits-observed.scss';

export const TraitsObserved: React.FC<TraitObservedProps> = (props) => {
  const { id, db, subIndex } = props;

  const [traitsObserved, setTraitsObserved] = useState<TraitObserved[]>([]);
  const traitList = getTraitListByAnalysis(db || 0);

  useEffect(() => {
    const source = Axios.CancelToken.source();
    const getTraitGroups = async () => {
      try {
        const to = await animalApi.getTraitObserved(id, db, subIndex, source.token);
        setTraitsObserved(to);
      } catch (e) {
        source.cancel();
      }
    };
    getTraitGroups();
  }, [db, id, subIndex]);

  return (
    <Container className="sg-trait-groups">
      <LoadContainer loading={!traitsObserved.length}>
        <Grid container>
          <Accordion
            title="Traits Observed"
            panelSummaryIcon={(
              <img
                src="/images/traits/group-trait-6.svg"
                alt="Traits Observed"
              />
)}
            enableFullScreenStickyHeader
          >
            <div className="row">
              <div className="trait-group">
                <Grid
                  className="card-container"
                  item
                  xs={12}
                  sm={6}
                  md={3}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Trait</TableCell>
                        {traitList.map((t) => (
                          <TableCell key={t.shortCode + t.traitCode.toUpperCase()}>{`${t.shortCode || ''}${t.traitCode.toUpperCase()}`}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>OBSERVED</TableCell>
                        { traitList.map((trait) => (
                          <TableCell>
                            {traitsObserved.filter((to) => to.trait === trait.traitCode
                            && (trait.shortCode === null || to.shortCode === trait.shortCode))
                              .pop()?.observed ? <CheckIcon color="primary" /> : <ClearIcon color="error" />}
                          </TableCell>
                        ))}
                      </TableRow>
                      {/* <TableRow> */}
                      {/*  <TableCell>PROGENY OBS.</TableCell> */}
                      {/*  { traitList.map((trait) => ( */}
                      {/*    <TableCell> */}
                      {/*      { traitsObserved.filter((to) => to.trait === trait.traitCode */}
                      {/*        && (trait.shortCode === null || to.shortCode === trait.shortCode)) */}
                      {/*        .pop()?.progCount || '-' } */}
                      {/*    </TableCell> */}
                      {/*  ))} */}
                      {/* </TableRow> */}
                    </TableBody>
                  </Table>
                </Grid>
              </div>
            </div>
          </Accordion>
        </Grid>
      </LoadContainer>
    </Container>
  );
};

(TraitsObserved as any).whyDidYouRender = true;
